import {
	values,
	merge,
	reduce
} from "lodash";
import { ENTITY_TYPES } from "constants.js";

const basePermissions = {
	"Blob": {
		"IsDisabled": false
	},
	"Compliance": {
		"IsDisabled": false
	},
	"Settings": {
		"IsDisabled": true
	},
	"Feedback": {
		"IsDisabled": false,
		"Actions": {
			"ShowPhoneNumber": true,
			"ShowRemoteSupport": true
		}
	},
	"Reporting": {
		"IsDisabled": false,
		"Actions": {
			"CanWithdraw": true,
			"CanSubmit": true,
			"CanDelete": true,
			"CanRestore": true,
			"CanEdit": true,
			"CanAmend": true,
			"CanCreate": true,
			"CanFileNegative": true,
			"CanWithdrawNegative": true, 
			"CanViewExports": false
		},
		"Details": {
			"IsDisabled": false,
			"Actions": {
				"CanDelete": true,
				"CanRestore": true,
				"CanCreate": true,
				"CanEdit": true
			}
		}
	},
	"History": {
		"IsDisabled": false,
		"Actions": {
			"CanExportByIds": true,
			"CanExportByDataLog": true,
			"CanExportByDifference": true
		}
	},
	"Administration": {
		"IsDisabled": false,
		"User": {
			"IsDisabled": true,
			"Actions": {
				"CanAdd": true,
				"CanEdit": true,
				"CanPermit": true,
				"CanFavorite": true,
				"CanResetPassword": true,
				"CanImpersonate": false,
				"CanViewLoginHistory": true,
				"CanSetSecurity": false
			}
		},
		"Entity": {
			"IsDisabled": true,
			"Actions": {
				"CanImport": false,
				"CanCreate": false
			},
			"Type": {}
		},
		"Analytics": {
			"IsDisabled": true
		},
		"Operations": {
			"IsDisabled": true
		},
		"Reporting": {
			"IsDisabled": false
		}
	}
};

export const baseEntityPermission = {
	"Code": "",
	"KnownAs": "",
	"IsDisabled": true,
	"Actions": {
		"CanAdd": true,
		"CanEdit": true,
		"CanDeactivate": true
	},
	"Relationships": {
		"IsDisabled": true,
		"Actions": {
			"CanAdd": true,
			"CanEdit": true,
			"CanRemove": true
		}
	},
	"Identifiers": {
		"IsDisabled": true,
		"Actions": {
			"CanAdd": true,
			"CanEdit": true,
			"CanRemove": true
		}
	},
	"Contacts": {
		"IsDisabled": true,
		"Actions": {
			"CanAdd": true,
			"CanEdit": true,
			"CanRemove": true
		}
	},
	"Seasons": {
		"IsDisabled": true,
		"Actions": {
			"CanAdd": false,
			"CanEdit": false,
			"CanRemove": false
		}
	},
	"Effective": {
		"IsDisabled": true,
		"Actions": {
			"CanAdd": true,
			"CanEdit": true,
			"CanRemove": true
		}
	},
	"Classifications": {
		"IsDisabled": true,
		"Actions": {
			"CanAdd": true,
			"CanRemove": true
		}
	},
	"History": {
		"IsDisabled": true
	},
	"Users": {
		"IsDisabled": true
	},
	"Reporting": {
		"IsDisabled": true
	}
};

const allTypePermissions = reduce(values(ENTITY_TYPES), (acc, entityType) => {
	if(entityType.Code === undefined) {
		return acc;
	}

	acc[entityType.Code] = merge({}, baseEntityPermission, { "Code": entityType.Code, "KnownAs": entityType.Name });

	return acc;
}, {});

const allTypePermissionsTransform = { "Administration": { "Entity": { "Type": allTypePermissions } } };

export const defaultPermissions = merge({}, basePermissions, allTypePermissionsTransform);
